define('bizzabo/routers/EventBriteRouter',['backbone', 'bizzabo/consts'], function(Backbone, Consts) {

    var EventBriteRouter = Backbone.Router.extend({
        routes : {
            'redirect?access_token=:token' : 'success',
            '*path' : 'failure'
        },

        success : function(token) {
            if (window.opener && window.opener.Backbone) {
                window.opener.Backbone.trigger(Consts.Notifications.eventBrite.OAUTH_SUCCESS, token);
            }

        },

        failure : function() {
            if (window.opener && window.opener.Backbone) {
                window.opener.Backbone.trigger(Consts.Notifications.eventBrite.OAUTH_FAILURE);
            }
        }
    });

    return EventBriteRouter;

});

